module.exports = __webpack_public_path__ + "static/media/csv.e511187f.svg";